import { render, staticRenderFns } from "./OrderBrand.vue?vue&type=template&id=1708f8dd&"
import script from "./OrderBrand.vue?vue&type=script&lang=ts&"
export * from "./OrderBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports